import { render, staticRenderFns } from "./DefectDialog.vue?vue&type=template&id=194a082f"
import script from "./DefectDialog.vue?vue&type=script&lang=ts"
export * from "./DefectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports